var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: " lots" },
    _vm._l(_vm.lotsList, function (l, i) {
      return _c("li", { key: i + l.lot_number }, [
        _c("p", { staticClass: "lots__title" }, [
          _c("b", [_vm._v("Лот " + _vm._s(l.lot_number) + ":")]),
          _vm._v(" " + _vm._s(l.purchase_title)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lots__info" },
          [
            l.lot_contracts_sum || l.lot_purchase_price
              ? _c("p", [
                  _c("b", [_vm._v("Начальная (максимальная) цена контракта:")]),
                  _vm._v(
                    " \n                " +
                      _vm._s(
                        _vm.moneyFormat(
                          l.lot_contracts_sum || l.lot_purchase_price,
                          2
                        )
                      ) +
                      " "
                  ),
                  _c("i", { staticClass: "uk-icon-rub" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            l.contracts && l.contracts.length
              ? _c("div", { staticClass: "lots__contracts" }, [
                  l.contracts.length > 1
                    ? _c("div", [
                        _c("b", [_vm._v("Контракты:")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(l.contracts, function (c, i) {
                            return _c("li", { key: i }, [
                              _vm.links.contract_number[_vm.law]
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "blue-red-hover-text",
                                      attrs: {
                                        href:
                                          _vm.links.contract_number[_vm.law] +
                                          c.contract_number,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(c.contract_number) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(c.contract_number)),
                                  ]),
                              _vm._v(" "),
                              c.contract_date_sign
                                ? _c("span", [
                                    _vm._v(
                                      " от " +
                                        _vm._s(
                                          _vm.dateParser(
                                            l.contracts[0].contract_date_sign
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              c.contract_sum
                                ? _c("span", [
                                    _vm._v(
                                      " на сумму " +
                                        _vm._s(
                                          _vm.moneyFormat(
                                            l.contracts[0].contract_sum,
                                            2
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("i", { staticClass: "uk-icon-rub" }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              c.contract_stage_title
                                ? _c("span", [
                                    _vm._v(
                                      " (" +
                                        _vm._s(c.contract_stage_title) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  l.contracts.length === 1
                    ? _c("p", [
                        _c("b", [_vm._v("Контракт:")]),
                        _vm._v(" "),
                        _vm.links.contract_number[_vm.law]
                          ? _c(
                              "a",
                              {
                                staticClass: "blue-red-hover-text",
                                attrs: {
                                  href:
                                    _vm.links.contract_number[_vm.law] +
                                    l.contracts[0].contract_number,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(l.contracts[0].contract_number) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(l.contracts[0].contract_number)),
                            ]),
                        _vm._v(" "),
                        l.contracts[0].contract_date_sign
                          ? _c("span", [
                              _vm._v(
                                " от " +
                                  _vm._s(
                                    _vm.dateParser(
                                      l.contracts[0].contract_date_sign
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        l.contracts[0].contract_sum
                          ? _c("span", [
                              _vm._v(
                                " на сумму " +
                                  _vm._s(
                                    _vm.moneyFormat(
                                      l.contracts[0].contract_sum,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                              _c("i", { staticClass: "uk-icon-rub" }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        l.contracts[0].contract_stage_title
                          ? _c("span", [
                              _vm._v(
                                " (" +
                                  _vm._s(l.contracts[0].contract_stage_title) +
                                  ")"
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            l.suppliers && l.suppliers.length
              ? _c(
                  "div",
                  { staticClass: "lots__suppliers" },
                  [
                    l.suppliers.length === 1
                      ? [
                          _c("b", [_vm._v("Победитель:")]),
                          _vm._v(" "),
                          l.suppliers[0].ogrn || l.suppliers[0].inn
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "card-link",
                                    {
                                      attrs: {
                                        ogrn:
                                          l.suppliers[0].ogrn ||
                                          l.suppliers[0].inn,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(l.suppliers[0].name) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("tooltip", {
                                    staticClass: "stay-on-row",
                                    attrs: {
                                      ogrn:
                                        l.suppliers[0].ogrn ||
                                        l.suppliers[0].inn,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("span", [_vm._v(_vm._s(l.suppliers[0].name))]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    l.suppliers.length > 1
                      ? [
                          _c("b", [_vm._v("Победители:")]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(l.suppliers, function (s, i) {
                              return _c("li", { key: i + s.ogrn }, [
                                s.ogrn || s.inn
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "card-link",
                                          { attrs: { ogrn: s.ogrn || s.inn } },
                                          [_vm._v(_vm._s(s.name))]
                                        ),
                                        _vm._v(" "),
                                        _c("tooltip", {
                                          staticClass: "stay-on-row",
                                          attrs: { ogrn: s.ogrn || s.inn },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v(_vm._s(s.name))]),
                              ])
                            }),
                            0
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            l.participants && l.participants.length
              ? _c(
                  "div",
                  { staticClass: "lots__participants" },
                  [
                    l.participants.length === 1
                      ? [
                          _c("b", [_vm._v("Участник:")]),
                          _vm._v(" "),
                          l.participants[0].ogrn || l.participants[0].inn
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "card-link",
                                    {
                                      attrs: {
                                        ogrn:
                                          l.participants[0].ogrn ||
                                          l.participants[0].inn,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(l.participants[0].name) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("tooltip", {
                                    staticClass: "stay-on-row",
                                    attrs: {
                                      ogrn:
                                        l.participants[0].ogrn ||
                                        l.participants[0].inn,
                                    },
                                  }),
                                  _vm._v(" "),
                                  l.participants[0].price
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                            Предложенная сумма: " +
                                            _vm._s(
                                              _vm.moneyFormat(
                                                l.participants[0].price,
                                                2
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("i", { staticClass: "uk-icon-rub" }),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    l.participants.length > 1
                      ? [
                          _c("b", [_vm._v("Участники:")]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(l.participants, function (p, i) {
                              return _c("li", { key: i + p.ogrn }, [
                                p.ogrn || p.inn
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "card-link",
                                          { attrs: { ogrn: p.ogrn || p.inn } },
                                          [_vm._v(_vm._s(p.name))]
                                        ),
                                        _vm._v(" "),
                                        _c("tooltip", {
                                          staticClass: "stay-on-row",
                                          attrs: { ogrn: p.ogrn || p.inn },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v(_vm._s(p.name))]),
                                _vm._v(" "),
                                p.price
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                Предложенная сумма: " +
                                          _vm._s(_vm.moneyFormat(p.price, 2)) +
                                          " "
                                      ),
                                      _c("i", { staticClass: "uk-icon-rub" }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                p.is_excluded
                                  ? _c("span", [_vm._v(" (Исключен)")])
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            l.products && l.products.length
              ? _c("div", { staticClass: "lots__products" }, [
                  _c("b", [_vm._v("Предмет контракта:")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(l.products, function (pr, i) {
                      return _c(
                        "li",
                        { key: i + pr.name, staticClass: "product" },
                        [
                          _c("app-accordion", [
                            _c(
                              "span",
                              {
                                staticClass: "product__title",
                                attrs: { slot: "title" },
                                slot: "title",
                              },
                              [_vm._v(_vm._s(pr.name))]
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass: "product__descr no_print",
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                pr.code
                                  ? _c("li", [
                                      _c("b", [_vm._v("Код позиции:")]),
                                      _vm._v(" " + _vm._s(pr.code)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                pr.okei_title
                                  ? _c("li", [
                                      _c("b", [_vm._v("Единица измрения:")]),
                                      _vm._v(" " + _vm._s(pr.okei_title)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                pr.price
                                  ? _c("li", [
                                      _c("b", [_vm._v("Цена за единицу:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.moneyFormat(pr.price, 2)) +
                                          " "
                                      ),
                                      _c("i", { staticClass: "uk-icon-rub" }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                pr.quantity
                                  ? _c("li", [
                                      _c("b", [_vm._v("Количество:")]),
                                      _vm._v(" " + _vm._s(pr.quantity)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                pr.sum_price
                                  ? _c("li", [
                                      _c("b", [_vm._v("Сумма:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.moneyFormat(pr.sum_price, 2)
                                          ) +
                                          " "
                                      ),
                                      _c("i", { staticClass: "uk-icon-rub" }),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            (l.purchases && l.purchases.length) ||
            (l.contracts && l.contracts.length) ||
            (l.protocols && l.protocols.length)
              ? _c(
                  "app-accordion",
                  {
                    staticClass:
                      "lots__additional_info additional_info no_print",
                  },
                  [
                    _c("b", { attrs: { slot: "title" }, slot: "title" }, [
                      _vm._v("Дополнительная информация"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "additional_info__content",
                        attrs: { slot: "content" },
                        slot: "content",
                      },
                      [
                        l.purchases && l.purchases.length
                          ? _vm._l(l.purchases, function (pur, i) {
                              return _c(
                                "div",
                                {
                                  key: i + pur.purchase_number,
                                  staticClass: "additional_info__card",
                                },
                                [
                                  _c("h4", [_vm._v("Закупка")]),
                                  _vm._v(" "),
                                  pur.purchase_number
                                    ? _c("p", [
                                        _c("b", [_vm._v("Номер извещения: ")]),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "blue-red-hover-text",
                                            attrs: {
                                              href:
                                                _vm.links.purchase_number[
                                                  _vm.law
                                                ] + pur.purchase_number,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(pur.purchase_number) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  pur.purchase_title
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v("Наименование закупки: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(pur.purchase_title)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  pur.purchase_sum
                                    ? _c("p", [
                                        _c("b", [_vm._v("Сумма закупки: ")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.moneyFormat(
                                                pur.purchase_sum,
                                                2
                                              )
                                            ) + " "
                                          ),
                                          _c("i", {
                                            staticClass: "uk-icon-rub",
                                          }),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  pur.purchase_type_title
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v("Способ размещения закупки: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(pur.purchase_type_title)
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  pur.purchase_date_add
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v("Дата размещения извещения: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dateParser(
                                                pur.purchase_date_add
                                              )
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        l.contracts && l.contracts.length
                          ? _vm._l(l.contracts, function (c, i) {
                              return _c(
                                "div",
                                {
                                  key: i + c.contract_number,
                                  staticClass: "additional_info__card",
                                },
                                [
                                  _c("h4", [_vm._v("Контракт")]),
                                  _vm._v(" "),
                                  c.contract_number
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v(
                                            "Реестровый номер контракта: "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(c.contract_number)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.contract_number_real
                                    ? _c("p", [
                                        _c("b", [_vm._v("Номер контракта: ")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(c.contract_number_real)
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.contract_date_sign
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v("Дата заключения контракта: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(c.contract_date_sign)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.law
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v("Федеральный закон №: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.law) + "-ФЗ"),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.contract_sum
                                    ? _c("p", [
                                        _c("b", [_vm._v("Цена контракта: ")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.moneyFormat(c.contract_sum, 2)
                                            ) + " "
                                          ),
                                          _c("i", {
                                            staticClass: "uk-icon-rub",
                                          }),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.contract_stage_title
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v("Стадия исполнения: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(c.contract_stage_title)
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.contract_date_exec_end
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v(
                                            "Дата окончания исполнения контракта: "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dateParser(
                                                c.contract_date_exec_end
                                              )
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        l.protocols && l.protocols.length
                          ? _vm._l(l.protocols, function (p, i) {
                              return _c(
                                "div",
                                {
                                  key: i + p.protocol_number,
                                  staticClass: "additional_info__card",
                                },
                                [
                                  _c("h4", [_vm._v("Протокол")]),
                                  _vm._v(" "),
                                  p.protocol_number
                                    ? _c("p", [
                                        _c("b", [_vm._v("Номер протокола: ")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(p.protocol_number)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.protocol_type_title
                                    ? _c("p", [
                                        _c("b", [_vm._v("Название: ")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(p.protocol_type_title)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.protocol_date
                                    ? _c("p", [
                                        _c("b", [
                                          _vm._v("Дата подписания протокола: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dateParser(p.protocol_date)
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }